import BaseRepository from "~/repositories/BaseRepository";
import BaseModel from "~/models/BaseModel";

class ProofreadersRepository extends BaseRepository {
  async create(params = {}) { // eslint-disable-line @typescript-eslint/explicit-module-boundary-types
    const url = "/api/v1/proofreader";
    const param = new BaseModel(params);
    const result = await this._post(url, param.toApiParams());
    return new BaseModel(result.data);
  }
}
export default ProofreadersRepository;
